// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Whole background of page should be mostly gray */
.ta {
  background-color: #eeeeee;
}

/* For the templates/users/home/admin.html - updated styles - Start*/
.ta-logout-search {
  margin-top: 74px;
}

.ta .header-block {
  padding: 10px 15px;
}

.ta .header-links {
  margin-top: 15px;
}

.ta .header-block .header-navbar a {
  text-decoration: none;
  color: #8e8e8e;
}

.ta .header-block .header-navbar .tab-active-class {
  font-weight: bold;
  color: white !important;
  background-color: grey;
}

.ta .header-block .header-navbar a:hover {
  text-decoration: none;
  color: white;
}

.ta .header-block .header-navbar a:focus {
  color: white;
  background-color: grey;
  font-weight: bold;
}

.ta .header-block .header-navbar .header-links {
  padding-right: 15px;
}

.ta .header-block .header-links .link-separator {
  padding: 0px 15px;
}

.ta .header-block .header-links .link-right {
  padding-right: 0px;
}

.ta .header-block .header-links a {
  font-size: 14px !important;
}

.ta .content-block .expand-block {
  height: 25px;
  background-color: #e5e5e5;
  width: 100%;
  margin-bottom: 3px;
}

.ta .content-block .expand-block a {
  float: right;
  padding-right: 5px;
  color: #919191;
}

.ta .content-block .expand-block a:hover {
  color: #1d1d1d;
  text-decoration: none;
}

.ta .content-block .expand-block span {
  font-size: 12px;
}

.ta .content-block .navbar-default {
  border-radius: 0px;
  box-shadow: 0px 3px 10px #a6a6a6;
  display: flex;
  margin-bottom: 2px;
  position: relative;
}

.ta .content-block .navbar-default .search-block {
  display: inline-block;
  padding: 0px 15px;
  width: 100%;
}

.ta .content-block .navbar-default .navbar-form {
  display: flex;
  padding: 10px 5px 13px;
  position: relative;
  width: 100%;
}

.ta .content-block .navbar-default .navbar-form span {
  height: 35px;
}

.ta .content-block .navbar-default .navbar-form .icon {
  height: 26px;
  margin: 5px 0px 0px 7px;
  width: 30px;
  position: absolute;
  right: 7px;
}

.ta .content-block .navbar-default .navbar-form .img-adduser {
  height: 30px;
}

.popoverHtml {
  min-width: 140px;
  text-align: center;
  padding-top: 15px;
  margin-bottom: 15px;
  z-index: 999;
}

.popoverHtml .action-links {
  padding-top: 15px;
}

.popoverHtml .action-links span {
  padding-right: 15px;
  padding-left: 15px;
}

.increase-popover-width {
  max-width: 400px;
}

.ta .content-block .navbar-default .left-form input {
  padding: 10px 10px 10px 38px;
}

.ta .content-block .navbar-default .search-block {
  display: inline-block;
  width: 100%;
}

.ta .content-block .navbar-default .right-form {
  float: left;
}

.ta .content-block .navbar-default .right-search {
  min-width: 375px;
  height: 100%;
}

.ta .content-block .navbar-default a {
  font-size: 12px !important;
}

.ta .batch-pipe {
  color: #777;
  width: 2px !important;
  padding-left: 10px;
  padding-top: 2px;
}

.ta .batch-transcript {
  width: 145px !important;
}

.ta .batch-links {
  min-width: 300px !important;
}

.ta .batch-edit {
  width: 75px !important;
}

.ta .batch-userview {
  width: 65px !important;
}

.ta .content-block .navbar-default .search-link {
  padding: 9px 0px 0px 12px;
}

.ta .content-block .navbar-default .pull-link-right {
  display: flex;
  margin: 18px 15px;
  min-width: 105px;
}

.ta .content-block .navbar-default .pull-link-right li {
  text-align: right;
  width: 100%;
}

.ta .content-block .navbar-default .pull-link-right .pull-span {
  margin: 0px 15px;
}

.ta .content-block .navbar-default .pull-link-left {
  display: flex;
  margin-top: 18px;
  min-width: 145px;
  margin-right: -30px !important;
}

.ta .content-block .navbar-default .filter-content {
  padding-left: 15px;
}

.ta .content-block .navbar-default .filter-content .toggle-height {
  height: 35px;
}

.ta .content-block .navbar-default .dropdown-content {
  margin-left: 15px;
}

.ta .content-block .navbar-default .dropdown-content a {
  text-decoration: none;
}

.ta .navbar-spacer {
  height: 58px;
}

.ta .content-block .table-block .advanced-search-block {
  position: absolute;
  background-color: white;
  z-index: 3;
}

.ta .content-block .table-block .advanced-search-block form input {
  height: 25px;
}

.ta .content-block .table-block .advanced-search-block form div {
  margin-bottom: 7px !important;
}

.ta .content-block .table-block .table button {
  background-color: white;
  border: none;
  border-radius: 0px;
}

.ta .content-block .table-block .table th {
  border: none;
  border: none;
  font-size: 12px !important;
}

.ta .content-block .table-block .table td {
  font-size: 12px !important;
}

.ta .content-block .table-block .table td a {
  font-size: 12px !important;
}

.ta .content-block .table-block .row-height {
  height: inherit;
}

.ta .content-block .table-block .table-wrapper {
  width: 100%;
}

.ta .content-block .table-block .table .col-width {
  min-width: 122px;
}

.ta .content-block .table-block .table .sortorder:after {
  content: '\\25b2';
}
.ta .content-block .table-block .table .sortorder.reverse:after {
  content: '\\25bc';
}

.table .sortorder:after {
  content: '\\25b2';
}
.table .sortorder.reverse:after {
  content: '\\25bc';
}

.ta .content-block .table-block .thead-prop {
  background-color: #e5e5e5;
}

.ta .content-block .table-block .tbody-prop {
  background-color: white;
}

.tbody-prop {
  background-color: white;
}

.ta .content-block .table-block .tbody-prop a {
  font-size: 12px;
}

.ta .content-block .table-block label {
  font-weight: normal;
}

.ta .content-block .table-block .edit-user-header {
  padding-top: 15px;
  padding-bottom: 10px;
  background-color: #e5e5e5;
}

.ta .content-block .table-block .edit-user-actions {
  top: 15px;
  float: right;
  padding-right: 15px;
  margin-top: 1.5rem;
}

.ta .content-block .table-block .edit-user-actions .action {
  float: left;
  margin-left: 2rem;
  margin-top: 11px;
}

.ta .content-block .table-block .edit-user-actions a.action {
  margin-top: 11px;
  padding-top: 11px;
}

.ta .content-block .table-block .edit-user-content {
  background-color: white;
  padding-top: 10px;
}

@media (min-width: 769px) and (max-width: 1023px) {
  .ta .content-block .table-block a.btn-default {
    padding: 1rem 2rem;
    font-size: 14px;
  }
}

@media (min-width: 1024px) and (max-width: 1399px) {
  .ta .content-block .table-block a.btn-default {
    padding: 1rem 3.5rem;
    font-size: 14px;
  }
}

body {
  overflow-x: hidden;
}

.ta .content-block .navbar-default .btn-custom-prop {
  min-width: 250px;
  height: 35px;
}

@media (min-width: 769px) and (max-width: 1023px) {
  .ta .content-block .navbar-default .btn-custom-prop {
    padding: 4px 35px 4px 6px;
    min-width: 125px;
    font-size: 12px;
  }

  .ta .content-block .navbar-default .right-search {
    min-width: 315px;
  }
}

@media (min-width: 1024px) and (max-width: 1399px) {
  .ta .content-block .navbar-default .btn-custom-prop {
    padding: 4px 25px 4px 6px;
    min-width: 135px;
    font-size: 12px;
  }

  .ta .content-block .navbar-default .right-search {
    min-width: 325px;
  }
}

/*CSS for the Error Displayer in TA (inside Tree)*/

.ta .content-block .tree-block .messaging {
  margin-right: 0px;
  margin-left: 0px;
}

.ta .content-block .tree-block .messaging .error {
  margin-top: 0px;
  margin-bottom: 15px;
}

.ta .content-block .tree-block .messaging .error span {
  font-size: 24px;
}

@media (min-width: 769px) and (max-width: 1023px) {
  .ta .content-block .tree-block .messaging .error span,
  .error-messaging-fix .messaging .error span {
    font-size: 16px;
  }
}

@media (min-width: 1024px) and (max-width: 1399px) {
  .ta .content-block .tree-block .messaging .error span,
  .error-messaging-fix .messaging .error span {
    font-size: 20px;
  }
}

.error-messaging-fix .messaging {
  margin-right: 0px !important;
  margin-left: 0px !important;
}

.error-messaging-fix .messaging .error span {
  font-size: 24px;
}

/*Styles to viewAssignmentsModal.html - START*/

#viewAssignmentsModal .modal-width {
  min-width: 950px !important;
}

#viewAssignmentsModal .modal-dialog .modal-content-prop {
  /*top: 40px; */
  background-color: #f2f2f2;
}

#viewAssignmentsModal .modal-dialog .modal-header .modal-title-prop {
  margin-left: 0px;
  margin-top: 10px !important;
}

#viewAssignmentsModal .modal-dialog .modal-header a {
  font-size: 14px;
}

#viewAssignmentsModal .modal-dialog .modal-header div {
  top: 25px !important;
}

#viewAssignmentsModal
  .modal-dialog
  .modal-content
  .modal-body
  .modal-body-wrapper {
  overflow: auto;
  height: 400px;
}

#viewAssignmentsModal .modal-dialog .modal-content .modal-body table {
  margin-bottom: 0px !important;
}

#viewAssignmentsModal .modal-dialog .modal-content .modal-body table thead tr {
  height: 45px;
}

#viewAssignmentsModal .modal-dialog .modal-content .modal-body table tbody tr {
  height: 40px;
}

#viewAssignmentsModal
  .modal-dialog
  .modal-content
  .modal-body
  table
  tbody
  .error-display-table
  header
  span {
  font-size: 16px;
}

#viewAssignmentsModal
  .modal-dialog
  .modal-content
  .modal-body
  table
  tr
  th
  button {
  background-color: #dfdfdf;
  border: 1px #dedede;
  font-weight: bold;
}

#viewAssignmentsModal .modal-dialog .modal-content .modal-body table tbody a {
  color: #000;
  font-size: 12px;
}

#viewAssignmentsModal
  .modal-dialog
  .modal-content
  .modal-body
  table
  tbody
  .removeInactive {
  color: #505050;
}

#viewAssignmentsModal
  .modal-dialog
  .modal-content
  .modal-body
  table
  tbody
  tr
  td
  a {
  text-decoration: none;
  border-bottom: 1px solid #a9a9a9;
}

#viewAssignmentsModal .modal-dialog .modal-content .modal-body table tbody td {
  padding-left: 10px;
  vertical-align: middle;
}

#viewAssignmentsModal
  .modal-dialog
  .modal-content
  .modal-body
  table
  tbody
  td
  [type='text'] {
  background-color: transparent;
}

#viewAssignmentsModal
  .modal-dialog
  .modal-content
  .modal-body
  .tbody-prop
  td
  .md-datepicker-button {
  display: none !important;
}

#viewAssignmentsModal
  .modal-dialog
  .modal-content
  .modal-body
  .tbody-prop
  td
  .md-datepicker-button
  .md-datepicker-input {
  border-bottom: 1px solid black;
}

#viewAssignmentsModal
  .modal-dialog
  .modal-content
  .modal-body
  .tbody-prop
  td
  .md-datepicker-input-container {
  padding-bottom: 0px;
  margin-left: 0px;
  border-bottom-color: #dfdfdf;
}

#viewAssignmentsModal
  .modal-dialog
  .modal-content
  .modal-body
  .tbody-prop
  td
  .md-datepicker-input-container
  input {
  border-bottom: 1px solid #a9a9a9;
}

#viewAssignmentsModal
  .modal-dialog
  .modal-content
  .modal-body
  .tbody-prop
  td
  .md-datepicker-input {
  min-width: 100px !important;
  font-size: 12px;
}

#viewAssignmentsModal
  .modal-dialog
  .modal-content
  .modal-body
  .action-container {
  margin-top: 25px;
  margin-bottom: 15px;
  padding-right: 0px;
}

#viewAssignmentsModal
  .modal-dialog
  .modal-content
  .modal-body
  .action-container
  .btn-cancel-action {
  text-decoration: underline;
  color: #76757a;
  margin-right: 15px;
}

#viewAssignmentsModal
  .modal-dialog
  .modal-content
  .modal-body
  .action-container
  .btn-apply-action {
  margin-right: 5px;
}

#viewAssignmentsModal .dueDatePicker {
  min-width: 190px !important;
  max-width: 190px !important;
  padding-top: 4px !important;
  padding-bottom: 4px !important;
}

#viewAssignmentsModal .td-no-padding {
  padding-top: 0px !important;
  padding-bottom: 0px !important;
}
/*Styles to viewAssignmentsModal.html - END*/

/*Styles to addAssignmentModal.html - START*/

#addNewAssignmentModal .modal-width {
  min-width: 850px !important;
}

#addNewAssignmentModal .modal-dialog .modal-content-prop {
  background-color: #f2f2f2;
}

#addNewAssignmentModal .modal-dialog .modal-header .modal-title-prop {
  margin-left: 0px;
  margin-top: 10px !important;
}

#addNewAssignmentModal .modal-dialog .modal-header a {
  font-size: 14px;
}

#addNewAssignmentModal .modal-dialog .modal-header .closer {
  top: 25px !important;
}

#addNewAssignmentModal
  .modal-dialog
  .modal-content
  .modal-body
  .modal-body-wrapper {
  overflow: auto;
  height: 350px;
}

#addNewAssignmentModal .modal-dialog .modal-content .modal-body table {
  margin-bottom: 0px !important;
}

#addNewAssignmentModal .modal-dialog .modal-content .modal-body table thead tr {
  height: 45px;
}

#addNewAssignmentModal .modal-dialog .modal-content .modal-body table tbody tr {
  height: 40px;
}

#addNewAssignmentModal
  .modal-dialog
  .modal-content
  .modal-body
  table
  tr
  button {
  background-color: #dfdfdf;
  border: 1px #dedede;
  font-weight: bold;
}

#addNewAssignmentModal .modal-dialog .modal-content .modal-body table tbody a {
  font-size: 12px;
}

#addNewAssignmentModal .modal-dialog .modal-content .modal-body table tbody td {
  padding-left: 10px;
}

#addNewAssignmentModal
  .modal-dialog
  .modal-content
  .modal-body
  .action-container {
  margin-top: 25px;
  margin-bottom: 15px;
  padding-right: 0px;
}

#addNewAssignmentModal
  .modal-dialog
  .modal-content
  .modal-body
  .action-container
  .btn-cancel-action {
  text-decoration: underline;
  color: #76757a;
  margin-right: 15px;
}

#addNewAssignmentModal
  .modal-dialog
  .modal-content
  .modal-body
  .action-container
  .btn-apply-action {
  margin-right: 5px;
}

/*Styles to viewAssignmentsModal.html - END


/*Styles to addAssignmentModal.html - START*/

#addChildCoursesModal .modal-width {
  min-width: 1280px !important;
}

#addChildCoursesModal .modal-dialog .modal-content-prop {
  background-color: #f2f2f2;
}

#addChildCoursesModal .modal-dialog .modal-header .modal-title-prop {
  margin-left: 0px;
  margin-top: 10px !important;
}

#addChildCoursesModal .modal-dialog .modal-header a {
  font-size: 14px;
}

#addChildCoursesModal .modal-dialog .modal-header .closer {
  top: 25px !important;
}

#addChildCoursesModal
  .modal-dialog
  .modal-content
  .modal-body
  .modal-body-wrapper {
  overflow: auto;
  height: 350px;
}

#addChildCoursesModal .modal-dialog .modal-content .modal-body table {
  margin-bottom: 0px !important;
}

#addChildCoursesModal .modal-dialog .modal-content .modal-body table thead tr {
  height: 45px;
}

#addChildCoursesModal .modal-dialog .modal-content .modal-body table tbody tr {
  height: 40px;
}

#addChildCoursesModal .modal-dialog .modal-content .modal-body table tr button {
  background-color: #dfdfdf;
  border: 1px #dedede;
  font-weight: bold;
}

#addChildCoursesModal .modal-dialog .modal-content .modal-body table tbody a {
  font-size: 12px;
}

#addChildCoursesModal .modal-dialog .modal-content .modal-body table tbody td {
  padding-left: 10px;
}

#addChildCoursesModal
  .modal-dialog
  .modal-content
  .modal-body
  .action-container {
  margin-top: 25px;
  margin-bottom: 15px;
  padding-right: 0px;
}

#addChildCoursesModal
  .modal-dialog
  .modal-content
  .modal-body
  .action-container
  .btn-cancel-action {
  text-decoration: underline;
  color: #76757a;
  margin-right: 15px;
}

#addChildCoursesModal
  .modal-dialog
  .modal-content
  .modal-body
  .action-container
  .btn-apply-action {
  margin-right: 5px;
}

/*Styles to admin.markSuccessfulModal.html - START*/

#markSuccessfulModal .btn-cancel-action {
  color: #76757a;
}

#markSuccessfulBody {
  padding: 3rem;
}

#markSuccessfulBody .margin-bottom {
  margin-bottom: 10px;
}

#markSuccessfulBody #successfulScore {
  border-color: rgb(204, 204, 204);
}

/*Styles to admin.markSuccessfulModal.html - END*/

.fade {
  opacity: 0;
  -webkit-transition: opacity 0.15s linear;
  transition: opacity 0.15s linear;
}

/*Styles to updateAssignmentErrorModal.html - START*/

#updateAssignmentErrorModal
  .modal-dialog
  .modal-content
  .modal-body
  .modal-body-wrapper {
  overflow: auto;
  height: 400px;
}

#updateAssignmentErrorModal .modal-dialog .modal-content-prop {
  background-color: #f2f2f2;
}

#updateAssignmentErrorModal .modal-dialog .modal-header {
  padding-left: 25px !important;
  padding-bottom: 25px;
}

#updateAssignmentErrorModal .modal-dialog .modal-body-prop {
  padding-top: 0px;
}

#updateAssignmentErrorModal .modal-dialog .modal-body .img-container {
  top: 25px;
  padding-left: 30px;
}

#updateAssignmentErrorModal .modal-dialog .modal-body .img-container img {
  height: 70px;
  width: 70px;
}

#updateAssignmentErrorModal .modal-dialog .modal-body .error-header {
  position: absolute;
  text-align: center;
  top: 125px;
}

#updateAssignmentErrorModal .modal-dialog .modal-body .error-header p {
  margin-bottom: 0px;
}

#updateAssignmentErrorModal .modal-dialog .modal-body .error-message {
  position: absolute;
  bottom: 100px;
  min-height: 125px;
  text-align: center;
  padding-bottom: 0px;
  padding-top: 15px;
}

#updateAssignmentErrorModal .modal-dialog .modal-body .error-action {
  position: absolute;
  bottom: 50px;
}

/*Styles to updateAssignmentErrorModal.html - END*/

#peopleGroupTable {
  background-color: white;
  margin-bottom: 15px;
}

#peopleGroupTable .header-wrapper {
  background-color: #d6d6d6;
}

#peopleGroupTable .header-wrapper .header-content {
  padding-left: 0px;
}

#peopleGroupTable .header-wrapper .header-content p {
  color: black;
  font-size: 26px;
  font-weight: bold;
  font-family: 'Rockwell';
  margin: 30px 0px 30px;
}

#peopleGroupTable .header-wrapper .header-action-wrapper {
  margin: 30px 0px 30px;
}

#peopleGroupTable .header-wrapper .header-action-wrapper .cancel-action {
  margin-right: 10px;
  text-decoration: underline;
  color: #6f6f6f;
}

#peopleGroupTable .group-name {
  margin-top: 15px;
}

#peopleGroupTable .group-name label {
  font-weight: bold !important;
  font-size: 14px;
}

#peopleGroupTable .people-container-wrapper {
  background-color: #f0f0f0;
  background-clip: content-box;
  margin-bottom: 15px;
  margin-top: 15px;
}

#peopleGroupTable .footer-wrapper {
  border-top: 2px solid #7a7a7a;
  padding-top: 15px;
  padding-bottom: 15px;
}

/* Rules Styles start from here*/

#allRulesTable {
  background-color: white;
  margin-bottom: 15px;
}

#allRulesTable .header-wrapper {
  background-color: #d6d6d6;
}

#allRulesTable .header-wrapper .header-content {
  padding-left: 0px;
  padding-bottom: 20px;
}

#allRulesTable .header-wrapper .header-content p {
  color: black;
  font-size: 26px;
  font-family: 'Rockwell';
  margin: 30px 0px 0px;
  font-weight: bold;
}

#allRulesTable .header-wrapper .header-action-wrapper {
  margin: 30px 0px 30px;
}

#allRulesTable .header-wrapper .header-action-wrapper .cancel-action {
  margin-right: 10px;
  text-decoration: underline;
  color: #6f6f6f;
  font-size: 16px;
  padding-right: 20px;
}

#allRulesTable .body-content {
  padding-top: 15px;
}

#allRulesTable .body-content .due-input {
  height: 30px;
  width: 60px;
  margin-right: 10px;
  text-align: center;
  border: 1px solid #ccc;
}

#allRulesTable .body-content .due-header {
  margin-top: 15px;
}

#allRulesTable .body-content .form-group {
  padding-left: 0px !important;
}

#allRulesTable .body-content .form-group .heading {
  font-weight: bold;
  font-size: 14px;
  margin-bottom: 0px;
}

#allRulesTable .body-content .form-group .heading-label {
  font-style: italic;
  font-size: 12px;
}

#allRulesTable .body-content .form-group .icon-container {
  position: absolute;
  padding-left: 10px;
  top: 27px;
}

#allRulesTable .body-content .form-group .icon-container .lock-icon {
  height: 18px;
  width: 14px;
}

#allRulesTable .body-content .form-group .input-padding {
  padding-left: 30px;
}

#allRulesTable .body-content .form-group .notification-label {
  margin-bottom: 10px;
}

#allRulesTable .footer-container {
  margin-top: 15px;
  margin-bottom: 15px;
}

#allRulesTable .footer-container hr {
  border-top: 3px solid #e5e5e5;
}

#allRulesTable .footer-container .footer-wrapper {
  margin-top: 10px;
  margin-bottom: 10px;
}

#allRulesTable .footer-container .footer-wrapper .btn-link {
  text-decoration: underline;
  font-size: 14px;
  color: black;
  padding-left: 20px;
  padding-right: 15px;
}

#allRulesTable .footer-container .footer-wrapper .btn-default {
  font-size: 14px;
  margin-left: 10px;
}

#allRulesTable .instructor-nav md-tabs-wrapper {
  padding-left: 15px;
}

#allRulesTable .people-content {
  padding-top: 0px !important;
  padding-left: 15px;
}

#allRulesTable .people-content .content-label {
  margin-bottom: 2px !important;
}

#allRulesTable .people-content .content-label label {
  font-size: 15px;
  font-weight: bold;
}

/*Custom Accordion Styles here*/

#allRulesTable .people-content .customAccordion .panel-group {
  margin-bottom: 0px;
}

#allRulesTable .people-content .customAccordion .panel-default {
  border-radius: 0px;
}

#allRulesTable .people-content .customAccordion .panel-default .toggleIcon {
  padding-right: 10px !important;
}

#allRulesTable .people-content .people-container-wrapper {
  background-color: #f0f0f0;
  background-clip: content-box;
  margin: 15px 0px 15px;
  padding-left: 0px;
  margin-top: 0px;
}

#allRulesTable .people-content .customAccordion .panel-title a {
  text-decoration: none;
  font-weight: bold;
}

#allRulesTable .people-content .customAccordion .panel-body {
  padding: 0px 0px 0px 0px;
  background-color: #f0f0f0;
}

#allRulesTable .people-content .plusClass:before {
  font-size: 14px;
  font-weight: bold;
  content: '+';
}

#allRulesTable .people-content .minusClass:before {
  font-size: 14px;
  font-weight: bold;
  content: '-';
}

/*Custom Accordion Styles here - Ends here*/
#allRulesTable .people-content .footer-container {
  padding-left: 0px;
}

#allRulesTable .people-content .footer-container span {
  font-weight: bold;
  color: #6c6c6c;
}

#allRulesTable .people-content .footer-container a {
  margin-left: 5px;
  margin-right: 10px;
  font-weight: bold;
  color: #6c6c6c;
}

#allRulesTable .assignment-content {
  padding-top: 0px !important;
}

#allRulesTable .assignment-content .content-label {
  margin-bottom: 0px !important;
}

#allRulesTable .assignment-content .content-label label {
  font-size: 15px;
  font-weight: bold;
  margin-right: 20px;
}

#allRulesTable .assignment-content .content-label span a {
  padding-left: 5px;
  font-size: 14px;
}

#allRulesTable .assignment-content .table {
  border-top: 1px solid #dcdcdc;
  border-bottom: 1px solid #dcdcdc;
}

#allRulesTable .assignment-content .table thead tr th button {
  padding-left: 0px;
}

#allRulesTable .assignment-content .table tbody tr td {
  padding: 10px !important;
}

#allRulesTable .assignment-content .table-bordered th {
  height: 40px;
}

#allRulesTable .disable-pointer {
  pointer-events: none;
}

#allRulesTable .enable-pointer {
  pointer-events: auto;
}

/*Dates css*/

#allRulesTable .dates-content {
  padding-top: 0px !important;
}

#allRulesTable .dates-content a {
  font-size: 12px;
}

#allRulesTable .dates-content .content-label {
  margin-bottom: 0px !important;
}

#allRulesTable .dates-content .content-label label {
  font-size: 15px;
  font-weight: bold;
  margin-right: 20px;
}

#allRulesTable .dates-content .table {
  border-top: 1px solid #dcdcdc;
  border-bottom: 1px solid #dcdcdc;
}

#allRulesTable .dates-content .table .custom-th {
  padding-right: 15px;
}

#allRulesTable .dates-content .table button {
  background-color: #f2f2f2;
}

#allRulesTable .dates-content .table .grey {
  background-color: #f2f2f2;
}

#allRulesTable .dates-content .table .white {
  background-color: white;
}

#allRulesTable .dates-content .table thead tr th button {
  padding-left: 0px;
}

#allRulesTable .dates-content .table thead tr th {
  vertical-align: middle;
  text-align: center;
}

#allRulesTable .dates-content .table tbody tr td {
  padding: 8px !important;
  vertical-align: middle;
}

#allRulesTable .dates-content .table tbody .form-group {
  margin-bottom: 0px !important;
}

#allRulesTable .dates-content .table tbody .form-control {
  height: 30px !important;
  line-height: 1.5 !important;
}

#allRulesTable .dates-content .table tbody .row {
  margin: 0px;
}

#allRulesTable .dates-content .table .dropdown-caret-wrapper {
  height: 30px;
  width: 25px;
  background-color: #eeeeee;
}

#allRulesTable .dates-content .table .dropdown-caret-wrapper span {
  margin-top: -4px;
}

#allRulesTable .dates-content .table .custom-row .form-group {
  padding-right: 1px;
}

#allRulesTable .dates-content .table .custom-row input {
  text-align: center;
}

#allRulesTable .dates-content .table-bordered th {
  height: 40px;
}

#allRulesTable .preview-content .info {
  margin-bottom: 0px;
}

#allRulesTable .preview-content label span {
  font-weight: bold;
}

#allRulesTable .preview-content .count-container {
  border: 1px solid #ababab;
  height: 100px;
  margin-right: 15px;
  margin-left: 15px;
  text-align: center;
}

#allRulesTable .preview-content .count-container span {
  line-height: 100px;
}

#allRulesTable .preview-content .count-container .wrapper p {
  font-size: 15px;
  margin-bottom: 5px;
}

#allRulesTable .preview-content .count-container .wrapper span {
  line-height: 0px;
  font-size: 32px;
  font-weight: bold;
}

#allRulesTable .preview-content .operand-container {
  height: 100px;
  text-align: center;
}

#allRulesTable .preview-content .operand-container span {
  line-height: 100px;
}

#allRulesTable .preview-content .wrapper {
  vertical-align: middle;
  display: inline-block;
}

#allRulesTable .preview-content .operand-container .wrapper p {
  font-size: 20px;
}

/*Styles to datesBatchEditModal.html - START*/

#datesBatchEditModal .modal-width {
  min-width: 800px !important;
}

#datesBatchEditModal .modal-dialog .modal-content-prop {
  background-color: #f2f2f2;
}

#datesBatchEditModal .modal-dialog .modal-header {
  padding-left: 25px !important;
  padding-bottom: 25px;
}

#datesBatchEditModal .modal-dialog .modal-header .modal-title-prop {
  margin-left: 0px;
  margin-top: 10px !important;
}

#datesBatchEditModal .modal-dialog .modal-header .closer {
  top: 25px !important;
}

#datesBatchEditModal .modal-dialog .modal-body label {
  font-size: 14px;
  font-weight: normal;
}

#datesBatchEditModal .modal-dialog .modal-body input[type='checkbox'],
input[type='radio'] {
  height: 15px;
  width: 15px;
}

#datesBatchEditModal .modal-dialog .modal-body .row {
  margin-right: 0px;
  margin-left: 0px;
  padding-top: 5px;
  padding-bottom: 5px;
}

#datesBatchEditModal .modal-dialog .modal-body .row .form-group {
  margin-bottom: 0px;
}

#datesBatchEditModal .modal-dialog .modal-body .row .form-group .radio-inline {
  margin-bottom: 5px;
}

#datesBatchEditModal .modal-dialog .modal-body .row .form-group .text-class {
  width: 40px;
  margin-right: 5px;
  margin-left: 5px;
}

#datesBatchEditModal .modal-dialog .modal-body .row .form-group .form-control {
  line-height: 1.5;
}

#datesBatchEditModal .modal-dialog .modal-body .row .form-group input {
  border: 1px solid #cccccc;
}

#datesBatchEditModal .modal-dialog .modal-footer .btn-link {
  color: black;
  text-decoration: underline;
  margin-right: 15px;
}

/*Styles to datesBatchEditModal.html - END*/

#preview-people .modal-body {
  padding-bottom: 0px;
}

#preview-people .modal-body table {
  background-color: white;
}

#preview-people .modal-body table button {
  background-color: #e0e0e0;
  font-weight: bold;
}

#copyRuleModal .modal-body table {
  background-color: white;
}

#copyRuleModal .modal-body table tbody button {
  background-color: white;
}

#copyRuleModal .modal-body table button {
  background-color: #efefef;
  font-weight: bold;
}

#copyRuleModal .modal-dialog {
  width: 75% !important;
}

#copyRuleModal .modal-body tbody td input[type='text'] {
  width: 90%;
  border: 1px solid #cccccc;
  height: 29px;
  padding-left: 5px;
}

#copyRuleModal .modal-body tbody td textarea {
  border: 1px solid #cccccc;
}

#copyRuleModal .modal-footer {
  padding-top: 0px;
}

#copyRuleModal .modal-footer .btn-link {
  color: black;
  text-decoration: underline;
  margin-right: 15px;
}

.ruleCreate {
  min-height: 40vh;
}

.control-label:after {
  content: '*';
  color: red;
}

.required-field:after {
  content: '*';
  color: red;
}

.ta.users .assignmentsHeader {
  margin: 0px;
}

.ta.users .assignmentsHeader h2 {
  padding: 0px;
}

.ta .table tr {
  border-bottom: 1px solid #e5e5e5;
}

/*Custom Date Picker*/

.customDatePicker {
  padding-right: 0px !important;
  margin-right: 0px !important;
}

.customDatePicker .md-datepicker-button {
  display: none;
}

.customDatePicker .md-datepicker-input-container {
  border: 1px solid #cccccc !important;
  margin-left: 0px !important;
  width: 100% !important;
}

.customDatePicker .md-datepicker-input-container input {
  text-align: left;
  font-size: 12px;
  padding-top: 5px;
  padding-left: 10px;
  width: inherit !important;
}

.customDatePicker .md-datepicker-input-container button {
  right: 5px;
  background-color: transparent !important;
}

/*This is the wrapper for the md-date-picker*/

.custom-md-container {
  background-color: #fff;
  padding: 0px;
  margin: 0px 0px 0px 0px;
  width: 100%;
  height: 31px;
}

.custom-md-container label {
  left: 0px !important;
  color: black;
  font-size: 15px;
  width: auto !important;
}

.custom-md-container .md-input-message-animation {
  margin-left: 0px !important;
  margin-top: -5px !important;
}

.custom-course-tabs {
  padding: 15px 0px 15px 0px;
}

.custom-course-tabs md-tabs-wrapper {
  padding-left: 15px !important;
}

/* Replace default date picker dropdown arrow button with a calendar icon*/
/* TODO  uncomment */
/* .customDatePicker .md-datepicker-triangle-button:after {
  content: url('/images/icons/datepicker_calendar_button.svg');
} */

.customDatePicker .md-datepicker-expand-triangle {
  display: none !important;
}

/* Dropdowns in ta header */
.ta .header-block div.header-navbar .form-group {
  display: inline;
}
.ta .header-block div.header-navbar .form-group label {
  margin-top: 10px;
  vertical-align: middle;
}

.ta .header-block div.header-navbar .form-group div.select-wrapper {
  margin-right: 5px;
}

.ta .header-block div.header-navbar .form-group select.form-control {
  margin-top: 10px;
  min-width: 100%;
}

.ta .header-block div.header-navbar .form-group div.dropdown-caret-wrapper {
  margin-top: 10px;
}

.ta .header-block div.header-navbar.pull-right div.circle-question {
  float: right;
}

.help-popover .popover-content {
  margin: 8px;
  width: auto;
  text-align: left;
  padding: 0px;
  line-height: 1.75;
}

#help-popover-full a {
  color: #505050;
  font-size: 12px;
  font-weight: 400;
  font-family: 'Verdana', 'Arial', 'sans-serif';
  background-color: transparent;
  text-decoration: none;
}

#help-popover-full hr {
  border: none;
  display: block;
  width: auto;
  height: 1px;
  margin: 12px 0px 6px 0px;
  background-color: #a1a1a1;
  opacity: 0.5;
}

#help-popover-full a:hover {
  color: #a1a1a1;
  text-decoration: underline;
  background-color: transparent;
}

.glyphicon-refresh-animate {
  -animation: spin 0.7s infinite linear;
  -webkit-animation: spin2 0.7s infinite linear;
}

@-webkit-keyframes spin2 {
  from {
    -webkit-transform: rotate(0deg);
  }
  to {
    -webkit-transform: rotate(360deg);
  }
}

@keyframes spin {
  from {
    transform: scale(1) rotate(0deg);
  }
  to {
    transform: scale(1) rotate(360deg);
  }
}

.no-animate {
  -webkit-transition: none !important;
  transition: none !important;
}

.roundCorners {
  padding: 5px;
  border-radius: 15px 15px 0px 0px;
  margin-bottom: 0px;
  text-align: center;
}

.inactiveBackground {
  background-color: #f9f9f9;
}

.activeBackground {
  background-color: #e4e4e4;
}

.historyHeader {
  border-bottom: 2px solid #e4e4e4;
}

.courseDateHistory {
  padding-left: 0px;
  padding-top: 5px;
  padding-bottom: 5px;
}

.ruleHistory {
  border-bottom: 1px solid #e5e5e5;
}

.ruleHistory div {
  padding-left: 0px;
  padding-right: 0px;
}

.peopleGroupHistoryHeader {
  border-bottom: 2px solid #e4e4e4;
  margin-bottom: 0px;
  padding-right: 15px;
}

#allRulesTable h4.panel-title {
  line-height: 0;
}
`, "",{"version":3,"sources":["webpack://./apps/lms/src/css/users/taExample.css"],"names":[],"mappings":"AAAA,mDAAmD;AACnD;EACE,yBAAyB;AAC3B;;AAEA,oEAAoE;AACpE;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,aAAa;EACb,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,WAAW;EACX,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,UAAU;AACZ;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE;IACE,kBAAkB;IAClB,eAAe;EACjB;AACF;;AAEA;EACE;IACE,oBAAoB;IACpB,eAAe;EACjB;AACF;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE;IACE,yBAAyB;IACzB,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,yBAAyB;IACzB,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA,kDAAkD;;AAElD;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE;;IAEE,eAAe;EACjB;AACF;;AAEA;EACE;;IAEE,eAAe;EACjB;AACF;;AAEA;EACE,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,eAAe;AACjB;;AAEA,8CAA8C;;AAE9C;EACE,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;;;;;EAKE,cAAc;EACd,aAAa;AACf;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;;;;;;;;;EASE,eAAe;AACjB;;AAEA;;;;;;;;EAQE,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;;;;;;;EAOE,cAAc;AAChB;;AAEA;;;;;;;;;EASE,qBAAqB;EACrB,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;;;;;;;;EAQE,6BAA6B;AAC/B;;AAEA;;;;;;;EAOE,wBAAwB;AAC1B;;AAEA;;;;;;;;EAQE,8BAA8B;AAChC;;AAEA;;;;;;;EAOE,mBAAmB;EACnB,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;;;;;;;;EAQE,gCAAgC;AAClC;;AAEA;;;;;;;EAOE,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;;;;;EAKE,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;;;;;;EAME,0BAA0B;EAC1B,cAAc;EACd,kBAAkB;AACpB;;AAEA;;;;;;EAME,iBAAiB;AACnB;;AAEA;EACE,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;EACE,2BAA2B;EAC3B,8BAA8B;AAChC;AACA,4CAA4C;;AAE5C,4CAA4C;;AAE5C;EACE,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;;;;;EAKE,cAAc;EACd,aAAa;AACf;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;;;;;;;EAOE,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;;;;EAKE,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;;;;;;EAME,0BAA0B;EAC1B,cAAc;EACd,kBAAkB;AACpB;;AAEA;;;;;;EAME,iBAAiB;AACnB;;AAEA;;;4CAG4C;;AAE5C;EACE,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;;;;;EAKE,cAAc;EACd,aAAa;AACf;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;;;;EAKE,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;;;;;;EAME,0BAA0B;EAC1B,cAAc;EACd,kBAAkB;AACpB;;AAEA;;;;;;EAME,iBAAiB;AACnB;;AAEA,mDAAmD;;AAEnD;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;AAClC;;AAEA,iDAAiD;;AAEjD;EACE,UAAU;EACV,wCAAwC;EACxC,gCAAgC;AAClC;;AAEA,oDAAoD;;AAEpD;;;;;EAKE,cAAc;EACd,aAAa;AACf;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;EAC7B,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA,kDAAkD;;AAElD;EACE,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,4BAA4B;EAC5B,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA,gCAAgC;;AAEhC;EACE,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,uBAAuB;EACvB,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,0BAA0B;EAC1B,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA,+BAA+B;;AAE/B;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;EACzB,4BAA4B;EAC5B,qBAAqB;EACrB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,wBAAwB;EACxB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,YAAY;AACd;;AAEA,2CAA2C;AAC3C;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,6BAA6B;EAC7B,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;;AAEA,YAAY;;AAEZ;EACE,2BAA2B;AAC7B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,eAAe;AACjB;;AAEA,6CAA6C;;AAE7C;EACE,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;EAC7B,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;;EAEE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA,2CAA2C;;AAE3C;EACE,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,UAAU;EACV,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gCAAgC;AAClC;;AAEA,qBAAqB;;AAErB;EACE,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,oCAAoC;EACpC,2BAA2B;EAC3B,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,wCAAwC;AAC1C;;AAEA,6CAA6C;;AAE7C;EACE,sBAAsB;EACtB,YAAY;EACZ,uBAAuB;EACvB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,YAAY;EACZ,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA,0EAA0E;AAC1E,oBAAoB;AACpB;;GAEG;;AAEH;EACE,wBAAwB;AAC1B;;AAEA,2BAA2B;AAC3B;EACE,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,6CAA6C;EAC7C,6BAA6B;EAC7B,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,WAAW;EACX,WAAW;EACX,wBAAwB;EACxB,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,0BAA0B;EAC1B,6BAA6B;AAC/B;;AAEA;EACE,qCAAqC;EACrC,6CAA6C;AAC/C;;AAEA;EACE;IACE,+BAA+B;EACjC;EACA;IACE,iCAAiC;EACnC;AACF;;AAEA;EACE;IACE,gCAAgC;EAClC;EACA;IACE,kCAAkC;EACpC;AACF;;AAEA;EACE,mCAAmC;EACnC,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,gCAAgC;EAChC,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;EAChC,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB","sourcesContent":["/* Whole background of page should be mostly gray */\n.ta {\n  background-color: #eeeeee;\n}\n\n/* For the templates/users/home/admin.html - updated styles - Start*/\n.ta-logout-search {\n  margin-top: 74px;\n}\n\n.ta .header-block {\n  padding: 10px 15px;\n}\n\n.ta .header-links {\n  margin-top: 15px;\n}\n\n.ta .header-block .header-navbar a {\n  text-decoration: none;\n  color: #8e8e8e;\n}\n\n.ta .header-block .header-navbar .tab-active-class {\n  font-weight: bold;\n  color: white !important;\n  background-color: grey;\n}\n\n.ta .header-block .header-navbar a:hover {\n  text-decoration: none;\n  color: white;\n}\n\n.ta .header-block .header-navbar a:focus {\n  color: white;\n  background-color: grey;\n  font-weight: bold;\n}\n\n.ta .header-block .header-navbar .header-links {\n  padding-right: 15px;\n}\n\n.ta .header-block .header-links .link-separator {\n  padding: 0px 15px;\n}\n\n.ta .header-block .header-links .link-right {\n  padding-right: 0px;\n}\n\n.ta .header-block .header-links a {\n  font-size: 14px !important;\n}\n\n.ta .content-block .expand-block {\n  height: 25px;\n  background-color: #e5e5e5;\n  width: 100%;\n  margin-bottom: 3px;\n}\n\n.ta .content-block .expand-block a {\n  float: right;\n  padding-right: 5px;\n  color: #919191;\n}\n\n.ta .content-block .expand-block a:hover {\n  color: #1d1d1d;\n  text-decoration: none;\n}\n\n.ta .content-block .expand-block span {\n  font-size: 12px;\n}\n\n.ta .content-block .navbar-default {\n  border-radius: 0px;\n  box-shadow: 0px 3px 10px #a6a6a6;\n  display: flex;\n  margin-bottom: 2px;\n  position: relative;\n}\n\n.ta .content-block .navbar-default .search-block {\n  display: inline-block;\n  padding: 0px 15px;\n  width: 100%;\n}\n\n.ta .content-block .navbar-default .navbar-form {\n  display: flex;\n  padding: 10px 5px 13px;\n  position: relative;\n  width: 100%;\n}\n\n.ta .content-block .navbar-default .navbar-form span {\n  height: 35px;\n}\n\n.ta .content-block .navbar-default .navbar-form .icon {\n  height: 26px;\n  margin: 5px 0px 0px 7px;\n  width: 30px;\n  position: absolute;\n  right: 7px;\n}\n\n.ta .content-block .navbar-default .navbar-form .img-adduser {\n  height: 30px;\n}\n\n.popoverHtml {\n  min-width: 140px;\n  text-align: center;\n  padding-top: 15px;\n  margin-bottom: 15px;\n  z-index: 999;\n}\n\n.popoverHtml .action-links {\n  padding-top: 15px;\n}\n\n.popoverHtml .action-links span {\n  padding-right: 15px;\n  padding-left: 15px;\n}\n\n.increase-popover-width {\n  max-width: 400px;\n}\n\n.ta .content-block .navbar-default .left-form input {\n  padding: 10px 10px 10px 38px;\n}\n\n.ta .content-block .navbar-default .search-block {\n  display: inline-block;\n  width: 100%;\n}\n\n.ta .content-block .navbar-default .right-form {\n  float: left;\n}\n\n.ta .content-block .navbar-default .right-search {\n  min-width: 375px;\n  height: 100%;\n}\n\n.ta .content-block .navbar-default a {\n  font-size: 12px !important;\n}\n\n.ta .batch-pipe {\n  color: #777;\n  width: 2px !important;\n  padding-left: 10px;\n  padding-top: 2px;\n}\n\n.ta .batch-transcript {\n  width: 145px !important;\n}\n\n.ta .batch-links {\n  min-width: 300px !important;\n}\n\n.ta .batch-edit {\n  width: 75px !important;\n}\n\n.ta .batch-userview {\n  width: 65px !important;\n}\n\n.ta .content-block .navbar-default .search-link {\n  padding: 9px 0px 0px 12px;\n}\n\n.ta .content-block .navbar-default .pull-link-right {\n  display: flex;\n  margin: 18px 15px;\n  min-width: 105px;\n}\n\n.ta .content-block .navbar-default .pull-link-right li {\n  text-align: right;\n  width: 100%;\n}\n\n.ta .content-block .navbar-default .pull-link-right .pull-span {\n  margin: 0px 15px;\n}\n\n.ta .content-block .navbar-default .pull-link-left {\n  display: flex;\n  margin-top: 18px;\n  min-width: 145px;\n  margin-right: -30px !important;\n}\n\n.ta .content-block .navbar-default .filter-content {\n  padding-left: 15px;\n}\n\n.ta .content-block .navbar-default .filter-content .toggle-height {\n  height: 35px;\n}\n\n.ta .content-block .navbar-default .dropdown-content {\n  margin-left: 15px;\n}\n\n.ta .content-block .navbar-default .dropdown-content a {\n  text-decoration: none;\n}\n\n.ta .navbar-spacer {\n  height: 58px;\n}\n\n.ta .content-block .table-block .advanced-search-block {\n  position: absolute;\n  background-color: white;\n  z-index: 3;\n}\n\n.ta .content-block .table-block .advanced-search-block form input {\n  height: 25px;\n}\n\n.ta .content-block .table-block .advanced-search-block form div {\n  margin-bottom: 7px !important;\n}\n\n.ta .content-block .table-block .table button {\n  background-color: white;\n  border: none;\n  border-radius: 0px;\n}\n\n.ta .content-block .table-block .table th {\n  border: none;\n  border: none;\n  font-size: 12px !important;\n}\n\n.ta .content-block .table-block .table td {\n  font-size: 12px !important;\n}\n\n.ta .content-block .table-block .table td a {\n  font-size: 12px !important;\n}\n\n.ta .content-block .table-block .row-height {\n  height: inherit;\n}\n\n.ta .content-block .table-block .table-wrapper {\n  width: 100%;\n}\n\n.ta .content-block .table-block .table .col-width {\n  min-width: 122px;\n}\n\n.ta .content-block .table-block .table .sortorder:after {\n  content: '\\25b2';\n}\n.ta .content-block .table-block .table .sortorder.reverse:after {\n  content: '\\25bc';\n}\n\n.table .sortorder:after {\n  content: '\\25b2';\n}\n.table .sortorder.reverse:after {\n  content: '\\25bc';\n}\n\n.ta .content-block .table-block .thead-prop {\n  background-color: #e5e5e5;\n}\n\n.ta .content-block .table-block .tbody-prop {\n  background-color: white;\n}\n\n.tbody-prop {\n  background-color: white;\n}\n\n.ta .content-block .table-block .tbody-prop a {\n  font-size: 12px;\n}\n\n.ta .content-block .table-block label {\n  font-weight: normal;\n}\n\n.ta .content-block .table-block .edit-user-header {\n  padding-top: 15px;\n  padding-bottom: 10px;\n  background-color: #e5e5e5;\n}\n\n.ta .content-block .table-block .edit-user-actions {\n  top: 15px;\n  float: right;\n  padding-right: 15px;\n  margin-top: 1.5rem;\n}\n\n.ta .content-block .table-block .edit-user-actions .action {\n  float: left;\n  margin-left: 2rem;\n  margin-top: 11px;\n}\n\n.ta .content-block .table-block .edit-user-actions a.action {\n  margin-top: 11px;\n  padding-top: 11px;\n}\n\n.ta .content-block .table-block .edit-user-content {\n  background-color: white;\n  padding-top: 10px;\n}\n\n@media (min-width: 769px) and (max-width: 1023px) {\n  .ta .content-block .table-block a.btn-default {\n    padding: 1rem 2rem;\n    font-size: 14px;\n  }\n}\n\n@media (min-width: 1024px) and (max-width: 1399px) {\n  .ta .content-block .table-block a.btn-default {\n    padding: 1rem 3.5rem;\n    font-size: 14px;\n  }\n}\n\nbody {\n  overflow-x: hidden;\n}\n\n.ta .content-block .navbar-default .btn-custom-prop {\n  min-width: 250px;\n  height: 35px;\n}\n\n@media (min-width: 769px) and (max-width: 1023px) {\n  .ta .content-block .navbar-default .btn-custom-prop {\n    padding: 4px 35px 4px 6px;\n    min-width: 125px;\n    font-size: 12px;\n  }\n\n  .ta .content-block .navbar-default .right-search {\n    min-width: 315px;\n  }\n}\n\n@media (min-width: 1024px) and (max-width: 1399px) {\n  .ta .content-block .navbar-default .btn-custom-prop {\n    padding: 4px 25px 4px 6px;\n    min-width: 135px;\n    font-size: 12px;\n  }\n\n  .ta .content-block .navbar-default .right-search {\n    min-width: 325px;\n  }\n}\n\n/*CSS for the Error Displayer in TA (inside Tree)*/\n\n.ta .content-block .tree-block .messaging {\n  margin-right: 0px;\n  margin-left: 0px;\n}\n\n.ta .content-block .tree-block .messaging .error {\n  margin-top: 0px;\n  margin-bottom: 15px;\n}\n\n.ta .content-block .tree-block .messaging .error span {\n  font-size: 24px;\n}\n\n@media (min-width: 769px) and (max-width: 1023px) {\n  .ta .content-block .tree-block .messaging .error span,\n  .error-messaging-fix .messaging .error span {\n    font-size: 16px;\n  }\n}\n\n@media (min-width: 1024px) and (max-width: 1399px) {\n  .ta .content-block .tree-block .messaging .error span,\n  .error-messaging-fix .messaging .error span {\n    font-size: 20px;\n  }\n}\n\n.error-messaging-fix .messaging {\n  margin-right: 0px !important;\n  margin-left: 0px !important;\n}\n\n.error-messaging-fix .messaging .error span {\n  font-size: 24px;\n}\n\n/*Styles to viewAssignmentsModal.html - START*/\n\n#viewAssignmentsModal .modal-width {\n  min-width: 950px !important;\n}\n\n#viewAssignmentsModal .modal-dialog .modal-content-prop {\n  /*top: 40px; */\n  background-color: #f2f2f2;\n}\n\n#viewAssignmentsModal .modal-dialog .modal-header .modal-title-prop {\n  margin-left: 0px;\n  margin-top: 10px !important;\n}\n\n#viewAssignmentsModal .modal-dialog .modal-header a {\n  font-size: 14px;\n}\n\n#viewAssignmentsModal .modal-dialog .modal-header div {\n  top: 25px !important;\n}\n\n#viewAssignmentsModal\n  .modal-dialog\n  .modal-content\n  .modal-body\n  .modal-body-wrapper {\n  overflow: auto;\n  height: 400px;\n}\n\n#viewAssignmentsModal .modal-dialog .modal-content .modal-body table {\n  margin-bottom: 0px !important;\n}\n\n#viewAssignmentsModal .modal-dialog .modal-content .modal-body table thead tr {\n  height: 45px;\n}\n\n#viewAssignmentsModal .modal-dialog .modal-content .modal-body table tbody tr {\n  height: 40px;\n}\n\n#viewAssignmentsModal\n  .modal-dialog\n  .modal-content\n  .modal-body\n  table\n  tbody\n  .error-display-table\n  header\n  span {\n  font-size: 16px;\n}\n\n#viewAssignmentsModal\n  .modal-dialog\n  .modal-content\n  .modal-body\n  table\n  tr\n  th\n  button {\n  background-color: #dfdfdf;\n  border: 1px #dedede;\n  font-weight: bold;\n}\n\n#viewAssignmentsModal .modal-dialog .modal-content .modal-body table tbody a {\n  color: #000;\n  font-size: 12px;\n}\n\n#viewAssignmentsModal\n  .modal-dialog\n  .modal-content\n  .modal-body\n  table\n  tbody\n  .removeInactive {\n  color: #505050;\n}\n\n#viewAssignmentsModal\n  .modal-dialog\n  .modal-content\n  .modal-body\n  table\n  tbody\n  tr\n  td\n  a {\n  text-decoration: none;\n  border-bottom: 1px solid #a9a9a9;\n}\n\n#viewAssignmentsModal .modal-dialog .modal-content .modal-body table tbody td {\n  padding-left: 10px;\n  vertical-align: middle;\n}\n\n#viewAssignmentsModal\n  .modal-dialog\n  .modal-content\n  .modal-body\n  table\n  tbody\n  td\n  [type='text'] {\n  background-color: transparent;\n}\n\n#viewAssignmentsModal\n  .modal-dialog\n  .modal-content\n  .modal-body\n  .tbody-prop\n  td\n  .md-datepicker-button {\n  display: none !important;\n}\n\n#viewAssignmentsModal\n  .modal-dialog\n  .modal-content\n  .modal-body\n  .tbody-prop\n  td\n  .md-datepicker-button\n  .md-datepicker-input {\n  border-bottom: 1px solid black;\n}\n\n#viewAssignmentsModal\n  .modal-dialog\n  .modal-content\n  .modal-body\n  .tbody-prop\n  td\n  .md-datepicker-input-container {\n  padding-bottom: 0px;\n  margin-left: 0px;\n  border-bottom-color: #dfdfdf;\n}\n\n#viewAssignmentsModal\n  .modal-dialog\n  .modal-content\n  .modal-body\n  .tbody-prop\n  td\n  .md-datepicker-input-container\n  input {\n  border-bottom: 1px solid #a9a9a9;\n}\n\n#viewAssignmentsModal\n  .modal-dialog\n  .modal-content\n  .modal-body\n  .tbody-prop\n  td\n  .md-datepicker-input {\n  min-width: 100px !important;\n  font-size: 12px;\n}\n\n#viewAssignmentsModal\n  .modal-dialog\n  .modal-content\n  .modal-body\n  .action-container {\n  margin-top: 25px;\n  margin-bottom: 15px;\n  padding-right: 0px;\n}\n\n#viewAssignmentsModal\n  .modal-dialog\n  .modal-content\n  .modal-body\n  .action-container\n  .btn-cancel-action {\n  text-decoration: underline;\n  color: #76757a;\n  margin-right: 15px;\n}\n\n#viewAssignmentsModal\n  .modal-dialog\n  .modal-content\n  .modal-body\n  .action-container\n  .btn-apply-action {\n  margin-right: 5px;\n}\n\n#viewAssignmentsModal .dueDatePicker {\n  min-width: 190px !important;\n  max-width: 190px !important;\n  padding-top: 4px !important;\n  padding-bottom: 4px !important;\n}\n\n#viewAssignmentsModal .td-no-padding {\n  padding-top: 0px !important;\n  padding-bottom: 0px !important;\n}\n/*Styles to viewAssignmentsModal.html - END*/\n\n/*Styles to addAssignmentModal.html - START*/\n\n#addNewAssignmentModal .modal-width {\n  min-width: 850px !important;\n}\n\n#addNewAssignmentModal .modal-dialog .modal-content-prop {\n  background-color: #f2f2f2;\n}\n\n#addNewAssignmentModal .modal-dialog .modal-header .modal-title-prop {\n  margin-left: 0px;\n  margin-top: 10px !important;\n}\n\n#addNewAssignmentModal .modal-dialog .modal-header a {\n  font-size: 14px;\n}\n\n#addNewAssignmentModal .modal-dialog .modal-header .closer {\n  top: 25px !important;\n}\n\n#addNewAssignmentModal\n  .modal-dialog\n  .modal-content\n  .modal-body\n  .modal-body-wrapper {\n  overflow: auto;\n  height: 350px;\n}\n\n#addNewAssignmentModal .modal-dialog .modal-content .modal-body table {\n  margin-bottom: 0px !important;\n}\n\n#addNewAssignmentModal .modal-dialog .modal-content .modal-body table thead tr {\n  height: 45px;\n}\n\n#addNewAssignmentModal .modal-dialog .modal-content .modal-body table tbody tr {\n  height: 40px;\n}\n\n#addNewAssignmentModal\n  .modal-dialog\n  .modal-content\n  .modal-body\n  table\n  tr\n  button {\n  background-color: #dfdfdf;\n  border: 1px #dedede;\n  font-weight: bold;\n}\n\n#addNewAssignmentModal .modal-dialog .modal-content .modal-body table tbody a {\n  font-size: 12px;\n}\n\n#addNewAssignmentModal .modal-dialog .modal-content .modal-body table tbody td {\n  padding-left: 10px;\n}\n\n#addNewAssignmentModal\n  .modal-dialog\n  .modal-content\n  .modal-body\n  .action-container {\n  margin-top: 25px;\n  margin-bottom: 15px;\n  padding-right: 0px;\n}\n\n#addNewAssignmentModal\n  .modal-dialog\n  .modal-content\n  .modal-body\n  .action-container\n  .btn-cancel-action {\n  text-decoration: underline;\n  color: #76757a;\n  margin-right: 15px;\n}\n\n#addNewAssignmentModal\n  .modal-dialog\n  .modal-content\n  .modal-body\n  .action-container\n  .btn-apply-action {\n  margin-right: 5px;\n}\n\n/*Styles to viewAssignmentsModal.html - END\n\n\n/*Styles to addAssignmentModal.html - START*/\n\n#addChildCoursesModal .modal-width {\n  min-width: 1280px !important;\n}\n\n#addChildCoursesModal .modal-dialog .modal-content-prop {\n  background-color: #f2f2f2;\n}\n\n#addChildCoursesModal .modal-dialog .modal-header .modal-title-prop {\n  margin-left: 0px;\n  margin-top: 10px !important;\n}\n\n#addChildCoursesModal .modal-dialog .modal-header a {\n  font-size: 14px;\n}\n\n#addChildCoursesModal .modal-dialog .modal-header .closer {\n  top: 25px !important;\n}\n\n#addChildCoursesModal\n  .modal-dialog\n  .modal-content\n  .modal-body\n  .modal-body-wrapper {\n  overflow: auto;\n  height: 350px;\n}\n\n#addChildCoursesModal .modal-dialog .modal-content .modal-body table {\n  margin-bottom: 0px !important;\n}\n\n#addChildCoursesModal .modal-dialog .modal-content .modal-body table thead tr {\n  height: 45px;\n}\n\n#addChildCoursesModal .modal-dialog .modal-content .modal-body table tbody tr {\n  height: 40px;\n}\n\n#addChildCoursesModal .modal-dialog .modal-content .modal-body table tr button {\n  background-color: #dfdfdf;\n  border: 1px #dedede;\n  font-weight: bold;\n}\n\n#addChildCoursesModal .modal-dialog .modal-content .modal-body table tbody a {\n  font-size: 12px;\n}\n\n#addChildCoursesModal .modal-dialog .modal-content .modal-body table tbody td {\n  padding-left: 10px;\n}\n\n#addChildCoursesModal\n  .modal-dialog\n  .modal-content\n  .modal-body\n  .action-container {\n  margin-top: 25px;\n  margin-bottom: 15px;\n  padding-right: 0px;\n}\n\n#addChildCoursesModal\n  .modal-dialog\n  .modal-content\n  .modal-body\n  .action-container\n  .btn-cancel-action {\n  text-decoration: underline;\n  color: #76757a;\n  margin-right: 15px;\n}\n\n#addChildCoursesModal\n  .modal-dialog\n  .modal-content\n  .modal-body\n  .action-container\n  .btn-apply-action {\n  margin-right: 5px;\n}\n\n/*Styles to admin.markSuccessfulModal.html - START*/\n\n#markSuccessfulModal .btn-cancel-action {\n  color: #76757a;\n}\n\n#markSuccessfulBody {\n  padding: 3rem;\n}\n\n#markSuccessfulBody .margin-bottom {\n  margin-bottom: 10px;\n}\n\n#markSuccessfulBody #successfulScore {\n  border-color: rgb(204, 204, 204);\n}\n\n/*Styles to admin.markSuccessfulModal.html - END*/\n\n.fade {\n  opacity: 0;\n  -webkit-transition: opacity 0.15s linear;\n  transition: opacity 0.15s linear;\n}\n\n/*Styles to updateAssignmentErrorModal.html - START*/\n\n#updateAssignmentErrorModal\n  .modal-dialog\n  .modal-content\n  .modal-body\n  .modal-body-wrapper {\n  overflow: auto;\n  height: 400px;\n}\n\n#updateAssignmentErrorModal .modal-dialog .modal-content-prop {\n  background-color: #f2f2f2;\n}\n\n#updateAssignmentErrorModal .modal-dialog .modal-header {\n  padding-left: 25px !important;\n  padding-bottom: 25px;\n}\n\n#updateAssignmentErrorModal .modal-dialog .modal-body-prop {\n  padding-top: 0px;\n}\n\n#updateAssignmentErrorModal .modal-dialog .modal-body .img-container {\n  top: 25px;\n  padding-left: 30px;\n}\n\n#updateAssignmentErrorModal .modal-dialog .modal-body .img-container img {\n  height: 70px;\n  width: 70px;\n}\n\n#updateAssignmentErrorModal .modal-dialog .modal-body .error-header {\n  position: absolute;\n  text-align: center;\n  top: 125px;\n}\n\n#updateAssignmentErrorModal .modal-dialog .modal-body .error-header p {\n  margin-bottom: 0px;\n}\n\n#updateAssignmentErrorModal .modal-dialog .modal-body .error-message {\n  position: absolute;\n  bottom: 100px;\n  min-height: 125px;\n  text-align: center;\n  padding-bottom: 0px;\n  padding-top: 15px;\n}\n\n#updateAssignmentErrorModal .modal-dialog .modal-body .error-action {\n  position: absolute;\n  bottom: 50px;\n}\n\n/*Styles to updateAssignmentErrorModal.html - END*/\n\n#peopleGroupTable {\n  background-color: white;\n  margin-bottom: 15px;\n}\n\n#peopleGroupTable .header-wrapper {\n  background-color: #d6d6d6;\n}\n\n#peopleGroupTable .header-wrapper .header-content {\n  padding-left: 0px;\n}\n\n#peopleGroupTable .header-wrapper .header-content p {\n  color: black;\n  font-size: 26px;\n  font-weight: bold;\n  font-family: 'Rockwell';\n  margin: 30px 0px 30px;\n}\n\n#peopleGroupTable .header-wrapper .header-action-wrapper {\n  margin: 30px 0px 30px;\n}\n\n#peopleGroupTable .header-wrapper .header-action-wrapper .cancel-action {\n  margin-right: 10px;\n  text-decoration: underline;\n  color: #6f6f6f;\n}\n\n#peopleGroupTable .group-name {\n  margin-top: 15px;\n}\n\n#peopleGroupTable .group-name label {\n  font-weight: bold !important;\n  font-size: 14px;\n}\n\n#peopleGroupTable .people-container-wrapper {\n  background-color: #f0f0f0;\n  background-clip: content-box;\n  margin-bottom: 15px;\n  margin-top: 15px;\n}\n\n#peopleGroupTable .footer-wrapper {\n  border-top: 2px solid #7a7a7a;\n  padding-top: 15px;\n  padding-bottom: 15px;\n}\n\n/* Rules Styles start from here*/\n\n#allRulesTable {\n  background-color: white;\n  margin-bottom: 15px;\n}\n\n#allRulesTable .header-wrapper {\n  background-color: #d6d6d6;\n}\n\n#allRulesTable .header-wrapper .header-content {\n  padding-left: 0px;\n  padding-bottom: 20px;\n}\n\n#allRulesTable .header-wrapper .header-content p {\n  color: black;\n  font-size: 26px;\n  font-family: 'Rockwell';\n  margin: 30px 0px 0px;\n  font-weight: bold;\n}\n\n#allRulesTable .header-wrapper .header-action-wrapper {\n  margin: 30px 0px 30px;\n}\n\n#allRulesTable .header-wrapper .header-action-wrapper .cancel-action {\n  margin-right: 10px;\n  text-decoration: underline;\n  color: #6f6f6f;\n  font-size: 16px;\n  padding-right: 20px;\n}\n\n#allRulesTable .body-content {\n  padding-top: 15px;\n}\n\n#allRulesTable .body-content .due-input {\n  height: 30px;\n  width: 60px;\n  margin-right: 10px;\n  text-align: center;\n  border: 1px solid #ccc;\n}\n\n#allRulesTable .body-content .due-header {\n  margin-top: 15px;\n}\n\n#allRulesTable .body-content .form-group {\n  padding-left: 0px !important;\n}\n\n#allRulesTable .body-content .form-group .heading {\n  font-weight: bold;\n  font-size: 14px;\n  margin-bottom: 0px;\n}\n\n#allRulesTable .body-content .form-group .heading-label {\n  font-style: italic;\n  font-size: 12px;\n}\n\n#allRulesTable .body-content .form-group .icon-container {\n  position: absolute;\n  padding-left: 10px;\n  top: 27px;\n}\n\n#allRulesTable .body-content .form-group .icon-container .lock-icon {\n  height: 18px;\n  width: 14px;\n}\n\n#allRulesTable .body-content .form-group .input-padding {\n  padding-left: 30px;\n}\n\n#allRulesTable .body-content .form-group .notification-label {\n  margin-bottom: 10px;\n}\n\n#allRulesTable .footer-container {\n  margin-top: 15px;\n  margin-bottom: 15px;\n}\n\n#allRulesTable .footer-container hr {\n  border-top: 3px solid #e5e5e5;\n}\n\n#allRulesTable .footer-container .footer-wrapper {\n  margin-top: 10px;\n  margin-bottom: 10px;\n}\n\n#allRulesTable .footer-container .footer-wrapper .btn-link {\n  text-decoration: underline;\n  font-size: 14px;\n  color: black;\n  padding-left: 20px;\n  padding-right: 15px;\n}\n\n#allRulesTable .footer-container .footer-wrapper .btn-default {\n  font-size: 14px;\n  margin-left: 10px;\n}\n\n#allRulesTable .instructor-nav md-tabs-wrapper {\n  padding-left: 15px;\n}\n\n#allRulesTable .people-content {\n  padding-top: 0px !important;\n  padding-left: 15px;\n}\n\n#allRulesTable .people-content .content-label {\n  margin-bottom: 2px !important;\n}\n\n#allRulesTable .people-content .content-label label {\n  font-size: 15px;\n  font-weight: bold;\n}\n\n/*Custom Accordion Styles here*/\n\n#allRulesTable .people-content .customAccordion .panel-group {\n  margin-bottom: 0px;\n}\n\n#allRulesTable .people-content .customAccordion .panel-default {\n  border-radius: 0px;\n}\n\n#allRulesTable .people-content .customAccordion .panel-default .toggleIcon {\n  padding-right: 10px !important;\n}\n\n#allRulesTable .people-content .people-container-wrapper {\n  background-color: #f0f0f0;\n  background-clip: content-box;\n  margin: 15px 0px 15px;\n  padding-left: 0px;\n  margin-top: 0px;\n}\n\n#allRulesTable .people-content .customAccordion .panel-title a {\n  text-decoration: none;\n  font-weight: bold;\n}\n\n#allRulesTable .people-content .customAccordion .panel-body {\n  padding: 0px 0px 0px 0px;\n  background-color: #f0f0f0;\n}\n\n#allRulesTable .people-content .plusClass:before {\n  font-size: 14px;\n  font-weight: bold;\n  content: '+';\n}\n\n#allRulesTable .people-content .minusClass:before {\n  font-size: 14px;\n  font-weight: bold;\n  content: '-';\n}\n\n/*Custom Accordion Styles here - Ends here*/\n#allRulesTable .people-content .footer-container {\n  padding-left: 0px;\n}\n\n#allRulesTable .people-content .footer-container span {\n  font-weight: bold;\n  color: #6c6c6c;\n}\n\n#allRulesTable .people-content .footer-container a {\n  margin-left: 5px;\n  margin-right: 10px;\n  font-weight: bold;\n  color: #6c6c6c;\n}\n\n#allRulesTable .assignment-content {\n  padding-top: 0px !important;\n}\n\n#allRulesTable .assignment-content .content-label {\n  margin-bottom: 0px !important;\n}\n\n#allRulesTable .assignment-content .content-label label {\n  font-size: 15px;\n  font-weight: bold;\n  margin-right: 20px;\n}\n\n#allRulesTable .assignment-content .content-label span a {\n  padding-left: 5px;\n  font-size: 14px;\n}\n\n#allRulesTable .assignment-content .table {\n  border-top: 1px solid #dcdcdc;\n  border-bottom: 1px solid #dcdcdc;\n}\n\n#allRulesTable .assignment-content .table thead tr th button {\n  padding-left: 0px;\n}\n\n#allRulesTable .assignment-content .table tbody tr td {\n  padding: 10px !important;\n}\n\n#allRulesTable .assignment-content .table-bordered th {\n  height: 40px;\n}\n\n#allRulesTable .disable-pointer {\n  pointer-events: none;\n}\n\n#allRulesTable .enable-pointer {\n  pointer-events: auto;\n}\n\n/*Dates css*/\n\n#allRulesTable .dates-content {\n  padding-top: 0px !important;\n}\n\n#allRulesTable .dates-content a {\n  font-size: 12px;\n}\n\n#allRulesTable .dates-content .content-label {\n  margin-bottom: 0px !important;\n}\n\n#allRulesTable .dates-content .content-label label {\n  font-size: 15px;\n  font-weight: bold;\n  margin-right: 20px;\n}\n\n#allRulesTable .dates-content .table {\n  border-top: 1px solid #dcdcdc;\n  border-bottom: 1px solid #dcdcdc;\n}\n\n#allRulesTable .dates-content .table .custom-th {\n  padding-right: 15px;\n}\n\n#allRulesTable .dates-content .table button {\n  background-color: #f2f2f2;\n}\n\n#allRulesTable .dates-content .table .grey {\n  background-color: #f2f2f2;\n}\n\n#allRulesTable .dates-content .table .white {\n  background-color: white;\n}\n\n#allRulesTable .dates-content .table thead tr th button {\n  padding-left: 0px;\n}\n\n#allRulesTable .dates-content .table thead tr th {\n  vertical-align: middle;\n  text-align: center;\n}\n\n#allRulesTable .dates-content .table tbody tr td {\n  padding: 8px !important;\n  vertical-align: middle;\n}\n\n#allRulesTable .dates-content .table tbody .form-group {\n  margin-bottom: 0px !important;\n}\n\n#allRulesTable .dates-content .table tbody .form-control {\n  height: 30px !important;\n  line-height: 1.5 !important;\n}\n\n#allRulesTable .dates-content .table tbody .row {\n  margin: 0px;\n}\n\n#allRulesTable .dates-content .table .dropdown-caret-wrapper {\n  height: 30px;\n  width: 25px;\n  background-color: #eeeeee;\n}\n\n#allRulesTable .dates-content .table .dropdown-caret-wrapper span {\n  margin-top: -4px;\n}\n\n#allRulesTable .dates-content .table .custom-row .form-group {\n  padding-right: 1px;\n}\n\n#allRulesTable .dates-content .table .custom-row input {\n  text-align: center;\n}\n\n#allRulesTable .dates-content .table-bordered th {\n  height: 40px;\n}\n\n#allRulesTable .preview-content .info {\n  margin-bottom: 0px;\n}\n\n#allRulesTable .preview-content label span {\n  font-weight: bold;\n}\n\n#allRulesTable .preview-content .count-container {\n  border: 1px solid #ababab;\n  height: 100px;\n  margin-right: 15px;\n  margin-left: 15px;\n  text-align: center;\n}\n\n#allRulesTable .preview-content .count-container span {\n  line-height: 100px;\n}\n\n#allRulesTable .preview-content .count-container .wrapper p {\n  font-size: 15px;\n  margin-bottom: 5px;\n}\n\n#allRulesTable .preview-content .count-container .wrapper span {\n  line-height: 0px;\n  font-size: 32px;\n  font-weight: bold;\n}\n\n#allRulesTable .preview-content .operand-container {\n  height: 100px;\n  text-align: center;\n}\n\n#allRulesTable .preview-content .operand-container span {\n  line-height: 100px;\n}\n\n#allRulesTable .preview-content .wrapper {\n  vertical-align: middle;\n  display: inline-block;\n}\n\n#allRulesTable .preview-content .operand-container .wrapper p {\n  font-size: 20px;\n}\n\n/*Styles to datesBatchEditModal.html - START*/\n\n#datesBatchEditModal .modal-width {\n  min-width: 800px !important;\n}\n\n#datesBatchEditModal .modal-dialog .modal-content-prop {\n  background-color: #f2f2f2;\n}\n\n#datesBatchEditModal .modal-dialog .modal-header {\n  padding-left: 25px !important;\n  padding-bottom: 25px;\n}\n\n#datesBatchEditModal .modal-dialog .modal-header .modal-title-prop {\n  margin-left: 0px;\n  margin-top: 10px !important;\n}\n\n#datesBatchEditModal .modal-dialog .modal-header .closer {\n  top: 25px !important;\n}\n\n#datesBatchEditModal .modal-dialog .modal-body label {\n  font-size: 14px;\n  font-weight: normal;\n}\n\n#datesBatchEditModal .modal-dialog .modal-body input[type='checkbox'],\ninput[type='radio'] {\n  height: 15px;\n  width: 15px;\n}\n\n#datesBatchEditModal .modal-dialog .modal-body .row {\n  margin-right: 0px;\n  margin-left: 0px;\n  padding-top: 5px;\n  padding-bottom: 5px;\n}\n\n#datesBatchEditModal .modal-dialog .modal-body .row .form-group {\n  margin-bottom: 0px;\n}\n\n#datesBatchEditModal .modal-dialog .modal-body .row .form-group .radio-inline {\n  margin-bottom: 5px;\n}\n\n#datesBatchEditModal .modal-dialog .modal-body .row .form-group .text-class {\n  width: 40px;\n  margin-right: 5px;\n  margin-left: 5px;\n}\n\n#datesBatchEditModal .modal-dialog .modal-body .row .form-group .form-control {\n  line-height: 1.5;\n}\n\n#datesBatchEditModal .modal-dialog .modal-body .row .form-group input {\n  border: 1px solid #cccccc;\n}\n\n#datesBatchEditModal .modal-dialog .modal-footer .btn-link {\n  color: black;\n  text-decoration: underline;\n  margin-right: 15px;\n}\n\n/*Styles to datesBatchEditModal.html - END*/\n\n#preview-people .modal-body {\n  padding-bottom: 0px;\n}\n\n#preview-people .modal-body table {\n  background-color: white;\n}\n\n#preview-people .modal-body table button {\n  background-color: #e0e0e0;\n  font-weight: bold;\n}\n\n#copyRuleModal .modal-body table {\n  background-color: white;\n}\n\n#copyRuleModal .modal-body table tbody button {\n  background-color: white;\n}\n\n#copyRuleModal .modal-body table button {\n  background-color: #efefef;\n  font-weight: bold;\n}\n\n#copyRuleModal .modal-dialog {\n  width: 75% !important;\n}\n\n#copyRuleModal .modal-body tbody td input[type='text'] {\n  width: 90%;\n  border: 1px solid #cccccc;\n  height: 29px;\n  padding-left: 5px;\n}\n\n#copyRuleModal .modal-body tbody td textarea {\n  border: 1px solid #cccccc;\n}\n\n#copyRuleModal .modal-footer {\n  padding-top: 0px;\n}\n\n#copyRuleModal .modal-footer .btn-link {\n  color: black;\n  text-decoration: underline;\n  margin-right: 15px;\n}\n\n.ruleCreate {\n  min-height: 40vh;\n}\n\n.control-label:after {\n  content: '*';\n  color: red;\n}\n\n.required-field:after {\n  content: '*';\n  color: red;\n}\n\n.ta.users .assignmentsHeader {\n  margin: 0px;\n}\n\n.ta.users .assignmentsHeader h2 {\n  padding: 0px;\n}\n\n.ta .table tr {\n  border-bottom: 1px solid #e5e5e5;\n}\n\n/*Custom Date Picker*/\n\n.customDatePicker {\n  padding-right: 0px !important;\n  margin-right: 0px !important;\n}\n\n.customDatePicker .md-datepicker-button {\n  display: none;\n}\n\n.customDatePicker .md-datepicker-input-container {\n  border: 1px solid #cccccc !important;\n  margin-left: 0px !important;\n  width: 100% !important;\n}\n\n.customDatePicker .md-datepicker-input-container input {\n  text-align: left;\n  font-size: 12px;\n  padding-top: 5px;\n  padding-left: 10px;\n  width: inherit !important;\n}\n\n.customDatePicker .md-datepicker-input-container button {\n  right: 5px;\n  background-color: transparent !important;\n}\n\n/*This is the wrapper for the md-date-picker*/\n\n.custom-md-container {\n  background-color: #fff;\n  padding: 0px;\n  margin: 0px 0px 0px 0px;\n  width: 100%;\n  height: 31px;\n}\n\n.custom-md-container label {\n  left: 0px !important;\n  color: black;\n  font-size: 15px;\n  width: auto !important;\n}\n\n.custom-md-container .md-input-message-animation {\n  margin-left: 0px !important;\n  margin-top: -5px !important;\n}\n\n.custom-course-tabs {\n  padding: 15px 0px 15px 0px;\n}\n\n.custom-course-tabs md-tabs-wrapper {\n  padding-left: 15px !important;\n}\n\n/* Replace default date picker dropdown arrow button with a calendar icon*/\n/* TODO  uncomment */\n/* .customDatePicker .md-datepicker-triangle-button:after {\n  content: url('/images/icons/datepicker_calendar_button.svg');\n} */\n\n.customDatePicker .md-datepicker-expand-triangle {\n  display: none !important;\n}\n\n/* Dropdowns in ta header */\n.ta .header-block div.header-navbar .form-group {\n  display: inline;\n}\n.ta .header-block div.header-navbar .form-group label {\n  margin-top: 10px;\n  vertical-align: middle;\n}\n\n.ta .header-block div.header-navbar .form-group div.select-wrapper {\n  margin-right: 5px;\n}\n\n.ta .header-block div.header-navbar .form-group select.form-control {\n  margin-top: 10px;\n  min-width: 100%;\n}\n\n.ta .header-block div.header-navbar .form-group div.dropdown-caret-wrapper {\n  margin-top: 10px;\n}\n\n.ta .header-block div.header-navbar.pull-right div.circle-question {\n  float: right;\n}\n\n.help-popover .popover-content {\n  margin: 8px;\n  width: auto;\n  text-align: left;\n  padding: 0px;\n  line-height: 1.75;\n}\n\n#help-popover-full a {\n  color: #505050;\n  font-size: 12px;\n  font-weight: 400;\n  font-family: 'Verdana', 'Arial', 'sans-serif';\n  background-color: transparent;\n  text-decoration: none;\n}\n\n#help-popover-full hr {\n  border: none;\n  display: block;\n  width: auto;\n  height: 1px;\n  margin: 12px 0px 6px 0px;\n  background-color: #a1a1a1;\n  opacity: 0.5;\n}\n\n#help-popover-full a:hover {\n  color: #a1a1a1;\n  text-decoration: underline;\n  background-color: transparent;\n}\n\n.glyphicon-refresh-animate {\n  -animation: spin 0.7s infinite linear;\n  -webkit-animation: spin2 0.7s infinite linear;\n}\n\n@-webkit-keyframes spin2 {\n  from {\n    -webkit-transform: rotate(0deg);\n  }\n  to {\n    -webkit-transform: rotate(360deg);\n  }\n}\n\n@keyframes spin {\n  from {\n    transform: scale(1) rotate(0deg);\n  }\n  to {\n    transform: scale(1) rotate(360deg);\n  }\n}\n\n.no-animate {\n  -webkit-transition: none !important;\n  transition: none !important;\n}\n\n.roundCorners {\n  padding: 5px;\n  border-radius: 15px 15px 0px 0px;\n  margin-bottom: 0px;\n  text-align: center;\n}\n\n.inactiveBackground {\n  background-color: #f9f9f9;\n}\n\n.activeBackground {\n  background-color: #e4e4e4;\n}\n\n.historyHeader {\n  border-bottom: 2px solid #e4e4e4;\n}\n\n.courseDateHistory {\n  padding-left: 0px;\n  padding-top: 5px;\n  padding-bottom: 5px;\n}\n\n.ruleHistory {\n  border-bottom: 1px solid #e5e5e5;\n}\n\n.ruleHistory div {\n  padding-left: 0px;\n  padding-right: 0px;\n}\n\n.peopleGroupHistoryHeader {\n  border-bottom: 2px solid #e4e4e4;\n  margin-bottom: 0px;\n  padding-right: 15px;\n}\n\n#allRulesTable h4.panel-title {\n  line-height: 0;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
